@let vs = presenter.viewState();

<div class="spa-day" role="listitem" [class.disabled]="vs.disabled">
  <span><ng-container *ngTemplateOutlet="vs.labelTemplate" /></span>
  @if (vs.removable) {
    <spa-icon
      fontSize="16px"
      role="button"
      [attr.aria-label]="vs.removeAriaLabel || null"
      [attr.aria-disabled]="vs.disabled ? 'true' : null"
      [attr.tabindex]="vs.disabled ? -1 : 0"
      (click)="onRemove()"
      (keydown.enter)="onRemove()"
      (keydown.space)="onRemove($event)"
      >close</spa-icon
    >
  }
</div>
